import { Component, OnInit, Input,Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseService } from '../../shared-service/base.service';
import { MyTasksService } from '../../learner/my-tasks/my-tasks.service';

declare var $: any;

@Component({
    selector: 'app-filter-panel',
    templateUrl: './filter-panel.component.html',
    styleUrls: ['./filter-panel.component.css']
})

export class FilterPanelComponent implements OnInit {

    public searchFormClass: Object | any = {};
    Order: boolean = false;

    SortByStatus: string = '';
    filterStatus: string = '';
    assignedFilterStatus: string='';
    search: string ='';
    titleName: string = '';

    @Input() IsSortBy: boolean = true;
    @Input() HeaderName: string | any;
    @Input() AssignedFilterList: Array<any>=[];
    @Input() StatusList: object | any;
    @Input() SortByList:Array<any>=[];
    @Input() isShowCalendar: boolean | any;
    

    @Output() SearchText = new EventEmitter<string>();
    @Output() AssignedFilterBy=new EventEmitter<string>();
    @Output() FilterBy = new EventEmitter<string>();
    @Output() SortBy = new EventEmitter<string>();

    constructor(private router: Router, private route: ActivatedRoute, private myTasksService: MyTasksService, public bs: BaseService) {
    }

    ngOnInit() {        
        this.bs.log('info', 'ngOnInit FilterPanelComponent');
        this.searchFormClass['search-form'] = true;
        this.searchFormClass['animated'] = true;
        this.searchFormClass['fadeInLeft'] = true;
        this.searchFormClass['hide'] = true;
        $('#txtSearch').val('');
        this.SortByStatus = this.bs.getResource('rbkey_RcntLBL_App');
        this.assignedFilterStatus = this.bs.getResource('rbkey_AllLBL');  
        this.filterStatus = this.bs.getResource('rbkey_AllLBL');
        this.titleName = this.HeaderName;
    }

    
    filterBy(filterBy:any)
    {
        console.log(filterBy);
        this.assignedFilterStatus = filterBy.name;  
        this.AssignedFilterBy.emit(filterBy.action);   
    }

    statusBy(filterBy:any) {
        console.log(filterBy);
        this.bs.log('info', filterBy);
        this.filterStatus = filterBy.name;  
        this.FilterBy.emit(filterBy.action);    
    }

    sortBy(filterBy:any) {
        this.bs.log('info', filterBy);
        this.SortBy.emit(filterBy.action); 
        this.SortByStatus = filterBy.name;
    }

    searchText(event: any, text: string) {
        if (event.key === "Enter") {
            console.log('info', text);
            this.search =text;
            this.searchFormClass['hide'] = true;
            this.SearchText.emit(text); 
            this.searchFormClass['hide'] = false;
            $('.rows learning-list-table').focus();
            return false;
        }
    }

    openCloseSearch(show:any) {
        if (show) {
            this.searchFormClass['hide'] = false;
        } else {
            this.searchFormClass['hide'] = true;
            $('.rows learning-list-table').focus();
            $('#txtSearch').val('');                
        }                
    }

    RedToCalenderView() {
         this.bs.isLrngClnder = true;   
         this.myTasksService.updateStoreData('calView',"month");
         this.router.navigate([{ outlets: { currentTaskList: ['calender-list', { time: new Date().getTime() }] } }], { relativeTo: this.route.parent });
     
    }
}

